import { isNonEmptyNumber } from '@labrav/common'
import { useStyles } from './AzurePricingSection.styles'

export const DisplayValueData = ({
  value,
  id,
  isPrice,
  isUnlimited,
}: {
  value?: number
  id: string
  isPrice?: boolean
  isUnlimited?: boolean
}) => {
  const { classes } = useStyles()
  return (
    <p className={classes.description} data-testid={`display-${id}`}>
      {isUnlimited ? (
        'Unlimited'
      ) : (
        <>
          {isPrice ? '$' : ''}
          {isNonEmptyNumber(value) ? value : '-'}
        </>
      )}
    </p>
  )
}
